import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);

export const statistics = (() => {
    const charts = document.querySelectorAll(".statistics");

    if (!charts.length) return;


    const getOrCreateLegendList = (chart, id) => {
        const legendContainer = document.getElementById(id);
        let listContainer = legendContainer.querySelector('ul');

        if (!listContainer) {
            listContainer = document.createElement('ul');
            listContainer.classList.add("statistics-legendList");
            legendContainer.appendChild(listContainer);
        }

        return listContainer;
    };

    const htmlLegendPlugin = {
        id: 'htmlLegend',
        afterUpdate(chart, args, options) {
            const ul = getOrCreateLegendList(chart, options.containerID);

            // Remove old legend items
            while (ul.firstChild) {
                ul.firstChild.remove();
            }

            // Reuse the built-in legendItems generator
            const items = chart.options.plugins.legend.labels.generateLabels(chart);

            items.forEach(item => {
                const li = document.createElement('li');
                li.classList.add("statistics-legendItem");

                li.onclick = () => {
                    const { type } = chart.config;
                    if (type === 'pie' || type === 'doughnut') {
                        // Pie and doughnut charts only have a single dataset and visibility is per item
                        chart.toggleDataVisibility(item.index);
                    } else {
                        chart.setDatasetVisibility(item.datasetIndex, !chart.isDatasetVisible(item.datasetIndex));
                    }
                    chart.update();
                };

                // Color box
                const boxSpan = document.createElement('span');
                boxSpan.style.background = item.fillStyle;
                boxSpan.classList.add("statistics-legendBox");

                // Text
                const textContainer = document.createElement('span');
                textContainer.classList.add("statistics-legendText");
                textContainer.style.textDecoration = item.hidden ? 'line-through' : '';

                const text = document.createTextNode(item.text);
                textContainer.appendChild(text);

                li.appendChild(boxSpan);
                li.appendChild(textContainer);
                ul.appendChild(li);
            });
        }
    };

    Array.from(charts).forEach((chart) => createChart(chart));

    function createChart(chart) {
        let data = JSON.parse(chart.getAttribute('data-json'));

        const ctx = document.getElementById(data.id);

        chart.classList.add("statistics--" + data.type);
       
        const myChart = new Chart(ctx, {
            type: data.type,
            data: data.chartdata,
            options: {
                maintainAspectRatio: true,
                responsive: true,
                hoverOffset: 4,
                borderWidth: 0,
                layout: {
                    padding: 6,
                    left: 0,
                },
                legend: {
                    display: false,
                },
                plugins: {
                    htmlLegend: {
                        containerID: 'legend-'+data.id,
                    },
                    legend: {
                        display: false,
                    }
                }
            },
            plugins: [htmlLegendPlugin],
        });
    };


})();
